export const getFazDelState = (state) => state.dvm.fazDel;
